module.exports = __webpack_public_path__ + "static/media/gurugram-icom-min.d14e1dd4.png";